import { mergeClasses } from '@blank/utilities'
import { Checkbox, CheckboxProps } from '../_ui/FormControl/Checkbox/Checkbox'
import { Message } from '../_ui/Message/Message'

export const MessageWithCheckbox = ({
  labelClassName,
  ...checkboxProps
}: CheckboxProps) => {
  return (
    <Message
      content={
        <Checkbox
          {...checkboxProps}
          labelClassName={mergeClasses(
            'text-base text-info-600 w-full h-full',
            labelClassName
          )}
        />
      }
    />
  )
}
